module.exports = __webpack_public_path__ + "static/media/square-purple-1.79c1998f.png";